import styled, { css } from 'styled-components';

import { FONT_NAMES, FONT_WEIGHT } from 'core/styles/fonts';
import { Cta } from 'core/components/Cta/Cta.style';
import * as mx from 'core/styles/mixins';
import * as vr from 'core/styles/variables';

import { Pill as PillBase } from '../../../Header.style';

export { BtnWrapper, Ul } from '../AdditionalLinksGroup.style';

export const notificationTitle: any = css`
	font-size: 18px;
	line-height: 28px;
	font-family: ${FONT_NAMES.GOTHAM_ROUNDED_MEDIUM};
	font-weight: ${FONT_WEIGHT.MEDIUM};
`;

export const Pill = styled(PillBase as any)<{
	noUreadMessages?: boolean;
}>`
	padding: 0;
	${({ noUreadMessages }) =>
		noUreadMessages &&
		css`
			background-color: ${({ theme }) =>
				theme.core.getCompositionColor('darkGrey')};
		`}
`;

export const NotificationsContainer = styled.div`
	width: 470px;
`;

export const NotificationsTitleWrapper = styled.div<any>`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 20px 14px;

	* {
		margin: 0;
	}
`;

export const Content = styled.div<{ padding?: string }>`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	${({ padding }) =>
		padding &&
		css`
			border-top: 1px ${({ theme }) => theme.global.borders.hr} solid;
			align-items: center;
			padding: ${padding};
		`}
	p {
		margin: 0;
	}

	img {
		${mx.circle('160px')}
		overflow: hidden;
	}
`;

export const Tile = styled.div`
	text-align: left;
	padding: 0 60px 0 24px;
	${({ theme }) => {
		const borderLeft = `3px solid ${theme.global.colors.primary.color}`;
		const borderTop = `1px solid ${theme.global.borders.hr}`;

		return css`
			border-top: ${borderTop};
			&:hover {
				a {
					color: ${vr.brandBlack};
				}
				border-left: ${borderLeft};
				background-color: ${({ theme }: any) =>
					theme.core.getCompositionColor('lightBlue')};
			}
		`;
	}}
	${Cta} {
		a {
			text-align: left;
			font-family: ${FONT_NAMES.OPEN_SANS};
			font-weight: ${FONT_WEIGHT.REGULAR};
			margin-top: 16px;
			color: ${vr.brandBlack};
			&:hover {
				color: ${vr.brandBlack};
			}
		}
	}
`;
